import createReactComponent from "../createReactComponent";
import defaultAttributes from "../defaultAttributes";
var Thermometer = createReactComponent("Thermometer", ["svg", defaultAttributes, [["path", {
  d: "M14 14.76V3.5a2.5 2.5 0 00-5 0v11.26a4.5 4.5 0 105 0z",
  key: "1secgz"
}]]]);
export default Thermometer;